import type { AttendanceStatus } from './status.ts';

export type AttendanceDivisionConfig = {
  divisionId: string;
  label: string;
};

export type AttendanceGradeConfig = {
  gradeId: string;
  divisionId: string;
  label: string;
};

export type AttendanceClassroomConfig = {
  classroomId: string;
  gradeId: string;
  label: string;
  teacherId?: string | null;
  teacherName?: string | null;
};

export type AttendancePeriodConfig = {
  periodId: string;
  label: string;
  sortOrder: number;
};

export const DEFAULT_ATTENDANCE_PERIODS = [
  { periodId: 'period-1', label: '1st Period', sortOrder: 1 },
  { periodId: 'period-2', label: '2nd Period', sortOrder: 2 },
  { periodId: 'period-3', label: '3rd Period', sortOrder: 3 },
  { periodId: 'period-4', label: '4th Period', sortOrder: 4 },
  { periodId: 'period-5', label: '5th Period', sortOrder: 5 },
  { periodId: 'period-6', label: '6th Period', sortOrder: 6 },
  { periodId: 'period-7', label: '7th Period', sortOrder: 7 },
] as const satisfies readonly AttendancePeriodConfig[];

export type AttendanceRosterMembershipConfig = {
  studentId: string;
  studentName: string;
  familyId?: string | null;
  classroomId: string;
};

export type AttendanceSchoolCalendarConfig = {
  activeWeekdays: number[];
  defaultStatus: Extract<AttendanceStatus, 'present'>;
};

export type AttendanceControlPlaneConfig = {
  divisions: AttendanceDivisionConfig[];
  grades: AttendanceGradeConfig[];
  classrooms: AttendanceClassroomConfig[];
  periods: AttendancePeriodConfig[];
  rosterMemberships: AttendanceRosterMembershipConfig[];
  schoolCalendar: AttendanceSchoolCalendarConfig;
  updatedAt: number;
  updatedBy: string;
};
